import {
  SAVE_SESSION,
  SMS_REQUEST,
  CLEAR_SESSION,
  CREATE_SESSION,
  TOKEN_VERIFY,
  SAVE_LAST_DIGITS,
  SAVE_CLIENT_INFO,
  SAVE_CLIENT_TYPE,
  FETCH_CLIENT, SAVE_CLIENT_MSISDN,
  SAVE_CPF, SAVE_SESSION_ID,
} from '../constants/actionTypes';

const doSaveSessionId = id => ({
  type: SAVE_SESSION_ID,
  id,
});

const doSaveSession = (id, msisdn, cpf, channel) => ({
  type: SAVE_SESSION,
  id,
  msisdn,
  cpf,
  channel,
});

const doSaveClientInfo = clientInfo => ({
  type: SAVE_CLIENT_INFO,
  payload: clientInfo,
});

const doSaveClientType = clientType => ({
  type: SAVE_CLIENT_TYPE,
  payload: clientType,
});

const doSaveClientMsisdn = msisdn => ({
  type: SAVE_CLIENT_MSISDN,
  payload: msisdn,
});

const doRequestSMS = plan => ({
  type: SMS_REQUEST,
  plan,
});

const doVerifyToken = (plan, token) => ({
  type: TOKEN_VERIFY,
  payload: {
    plan,
    token,
  },
});

const doCreateSession = ({ canal, msisdn, cpf, adabas, plano }) => ({
  type: CREATE_SESSION,
  payload: {
    channel: canal,
    msisdn,
    cpf,
    adabas,
    plan: plano,
  },
});

const doFetchClientBySession = (sessionId, planCode) => ({
  type: FETCH_CLIENT,
  payload: {
    sessionId,
    planCode,
  },
});

const doClearSession = () => ({
  type: CLEAR_SESSION,
});

const doSaveLastDigits = digits => ({
  type: SAVE_LAST_DIGITS,
  payload: digits,
});

const doSaveCpf = cpf => ({
  type: SAVE_CPF,
  payload: cpf,
})

export {
  doSaveSession,
  doRequestSMS,
  doClearSession,
  doCreateSession,
  doVerifyToken,
  doSaveLastDigits,
  doSaveClientInfo,
  doSaveClientType,
  doFetchClientBySession,
  doSaveClientMsisdn,
  doSaveCpf,
  doSaveSessionId,
};
